/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

import { Map, Record } from 'immutable';

export interface ImportState extends Map<string, any> {

  uploadFile: any;
  uploadFileLoading: any;
  uploadFileLoaded: any;
  uploadFileFailed: any;


}

export const ImportStateRecord = Record({

  uploadFile: {},
  uploadFileLoading: false,
  uploadFileLoaded: false,
  uploadFileFailed: false,

});
